import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Beard_1 = ({ facialHairColours }) => {
  const primary = facialHairColours.base;
  const secondary = facialHairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M319.7,919.6c32.8,70.9,64.4,86.3,104.5,79.4c55.2-9.5,81.3-178.2,100.7-325.2c0-0.1,0-0.1,0-0.2
		c0.6-27.5,0.8-51.8,0.8-63.5V393.7c0-2.1-3-2.4-3.5-0.4c-0.5,2.3-0.9,4.1-1,4.5c0,0.1,0,0.1,0,0.2c-0.3,2.7-1.2,11.5-1.5,14.2
		c-12.4,116.5-43.7,357.2-90.6,354.8c-0.3,0-0.6-0.1-0.9-0.3c-2.5-1.7-14.3-12.1-4-48.5c0.1-0.2,0.1-0.4,0.1-0.6
		c-0.3-2.7-2.9-21.6-24.5-22.6c-0.1,0-0.2,0-0.2,0c-21.6,1-24.2,19.9-24.5,22.6c0,0.2,0,0.4,0.1,0.6c10.3,36.4-1.6,46.8-4,48.5
		c-0.3,0.2-0.6,0.3-0.9,0.3c-50.5,2.5-82.9-276.7-93.1-379.2c-0.1-0.9-0.8-1.5-1.7-1.5h0c-1,0-1.8,0.8-1.8,1.8V610
		c0,10.9,0.2,32.7,0.7,57.8c0,0.1,0,0.1,0,0.2C284.8,764.5,288.4,852,319.7,919.6z"
        />
        <path
          fill={secondary}
          d="M494.9,808.2c0.2-25.8-1.3-49.4-3.9-69.7c-0.3-2.1-3.3-2-3.5,0.1c-11.4,115-38.9,197-48.9,223.9
		c-0.7,1.9-3.4,1.3-3.4-0.7c1-38,0.2-67.8-7.5-103.1c-0.4-2-3.4-1.7-3.5,0.3c-1.5,51.7-15.9,107.6-20.3,123.4
		c-0.4,1.6-2.5,1.8-3.3,0.3c-18.7-37.2-26.3-54.1-44.6-142.2c-0.4-2-3.3-1.8-3.5,0.2c-3.3,30.3,1,73.9,3.4,93.8
		c0.2,2.1-2.7,2.8-3.4,0.8c-11.2-31.9-28.3-127.6-37.2-191.2c-0.3-2.2-3.5-1.9-3.5,0.2c0.1,26.2,1.9,55.8,3.3,75
		c0.2,2.1-2.9,2.6-3.5,0.5c-31.3-127.5-32.1-245.9-35.2-362V692c0,35.3,3.8,91,8.9,123.1c11,69,24.2,119.7,37.7,156.8
		c0.8,2.1,3.8,1.1,3.4-1c-2.2-9.6-4.1-19.6-5.5-29.4c-0.3-2.1,2.8-2.8,3.4-0.7c3.5,12,8.5,28.9,14,46.9
		c12.9,42.3,30.3,72.1,49.6,82.3c8.9,4.7,14.5,4.3,14.5,4.3s2.3,0.2,6.4-1c22.2-6.4,42.7-37.8,57.4-86.1c9-29.8,16.8-61,17-80.7
		c0,0,0,26-4.2,62.8c-0.2,2.1,2.7,2.8,3.4,0.8c14.5-40.4,28.7-96.3,40-174.1c4.2-28.6,6-59.4,6-90.4V465.2
		c-2,129.9-21.3,279.5-30.4,343.2C498.1,810.6,494.9,810.4,494.9,808.2z"
        />
      </g>
    </>
  );
};

export default Beard_1;
